import urlTemplate from 'url-template';
import type {
  CapacityUsageGranularity,
  HydrogenCapacityCategory,
  HydrogenDirection,
  HydrogenFcfsBookingStatus,
  HydrogenFlowUnit,
  HydrogenRuntimeType,
  PriceTimeUnit,
} from 'src/apis/hydrogen-fcfs/types';
import { labelsToOptions } from 'src/utils/labels-to-options';
import { labelsToValues } from 'src/utils/labels-to-values';

export const capacityUsageGranularityLabels: Record<
  CapacityUsageGranularity,
  string
> = {
  DAYS: 'Days',
  MONTHS: 'Months',
  QUARTERS: 'Quarters',
  YEARS: 'Years',
};

export const capacityUsageGranularityValues = labelsToValues(
  capacityUsageGranularityLabels
);

export const capacityUsageGranularityOptions = labelsToOptions(
  capacityUsageGranularityLabels
);

export const hydrogenFlowUnitLabels: Record<HydrogenFlowUnit, string> = {
  KWH_H: 'kWh/h',
  MWH_H: 'MWh/h',
};

export const priceTimeUnitLabels: Record<PriceTimeUnit, string> = {
  YEAR: 'Year',
  QUARTER: 'Quarter',
  MONTH: 'Month',
  DAY: 'Day',
  HOUR: 'Hour',
};

export const hydrogenRuntimeTypeLabels: Record<HydrogenRuntimeType, string> = {
  YEAR: 'Yearly',
  QUARTER: 'Quarterly',
  MONTH: 'Monthly',
  DAY: 'Daily',
  WITHINDAY: 'Within-Day',
  CUSTOM: 'Custom',
};

export const hydrogenRuntimeTypeValues = labelsToValues(
  hydrogenRuntimeTypeLabels
);

export const hydrogenRuntimeTypeOptions = labelsToOptions(
  hydrogenRuntimeTypeLabels
);

export const hydrogenCapacityCategoryLabels: Record<
  HydrogenCapacityCategory,
  string
> = {
  FIRM: 'Firm',
  INTERRUPTIBLE: 'Interruptible',
};

export const hydrogenCapacityCategoryOptions = labelsToOptions(
  hydrogenCapacityCategoryLabels
);

export const hydrogenDirectionLabels: Record<HydrogenDirection, string> = {
  EXIT: 'Exit',
  ENTRY: 'Entry',
  BUNDLE: 'Bundle',
};

export const hydrogenDirectionValues = labelsToValues(hydrogenDirectionLabels);

export const hydrogenDirectionFilterOptions = labelsToOptions(
  hydrogenDirectionLabels
);

export const hydrogenFcfsBookingStatusLabels: Record<
  HydrogenFcfsBookingStatus,
  string
> = {
  OFFERED: 'Offered',
  REQUEST_REJECTED: 'Request Rejected',
  CAPACITY_ORDERED: 'Waiting for Approval',
  BOOKED: 'Booked',
  BOOKING_REJECTED: 'Booking Rejected',
  CANCELLED: 'Cancelled',
  PARTIALLY_CANCELLED: 'Partially Cancelled',
  ERROR: 'Error',
};

export const hydrogenFcfsBookingStatusValues = labelsToValues(
  hydrogenFcfsBookingStatusLabels
);

export const hydrogenFcfsBookingStatusOptions = labelsToOptions(
  hydrogenFcfsBookingStatusLabels
);

export const yesNoLabels: Record<'true' | 'false', string> = {
  true: 'Yes',
  false: 'No',
};

export const yesNoOptions = labelsToOptions(yesNoLabels);

export function yesNoValueToBoolean(
  value: 'true' | 'false' | undefined | null
): boolean | undefined {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return undefined;
}

export function expandUrlTempleRemoveQueryParams(url: string, params?: any) {
  return urlTemplate
    .parse(url)
    .expand(params ?? {})
    .replace(/\?.*$/, '');
}
